import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CryptoJsService } from "../../core/services/crypto-js.service";
import { AutoLogoutService } from './auto-logout';
import Swal from 'sweetalert2';
@Injectable()
export class LoginService {
  public isLoggingOut = false; // Bandera para evitar logout simultáneos

  constructor(
    private routes: Router,
    private http: HttpClient,
    private readonly localStorage: CryptoJsService,
    private autoLogout: AutoLogoutService
  ) { }

  /*****************************************
   * LOGIN NORMAL CONTRA KEYCLOAK
   *****************************************/
  keycloakLogin(userName: string, pass: string): Observable<any> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded;'
    );

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', userName)
      .set('password', pass)
      .set('client_id', environment.clientId);

    return this.http.post<any>(
      `${environment.apiUrl}/realms/${environment.realm}/protocol/openid-connect/token`,
      body.toString(),
      { headers }
    ).pipe(
      tap(resp => {
        const accessToken = resp.access_token;
        const refreshToken = resp.refresh_token;

        // Guardamos tokens SIEMPRE con las mismas keys
        this.localStorage.setItem('token', accessToken);
        this.localStorage.setItem('refresh_token', refreshToken);

        // Programamos auto-logout según el refresh token
        //this.autoLogout.scheduleFromRefreshToken(refreshToken);
      })
    );
  }

  /*****************************************
   * LOGIN "GUEST" O USUARIO FIJO
   *****************************************/
  // keycloakLoginGuest(client_id: string, client_secret: string): Observable<any> {
  //   const headers = new HttpHeaders().set(
  //     'Content-Type',
  //     'application/x-www-form-urlencoded;'
  //   );

  //   const body = new HttpParams()
  //     .set('grant_type', 'password')
  //     .set('client_id', environment.clientId)
  //     // Ajusta aquí usuario/clave guest como corresponda
  //     .set('username', 'pjimenez')
  //     .set('password', 'pjimenez');

  //   return this.http.post<any>(
  //     `${environment.apiUrl}/realms/${environment.realm}/protocol/openid-connect/token`,
  //     body.toString(),
  //     { headers }
  //   ).pipe(
  //     tap(resp => {
  //       const accessToken = resp.access_token;
  //       const refreshToken = resp.refresh_token;

  //       this.localStorage.setItem('token', accessToken);
  //       this.localStorage.setItem('refresh_token', refreshToken);

  //       this.autoLogout.scheduleFromRefreshToken(refreshToken);
  //     })
  //   );
  // }

  /*****************************************
   * REFRESH TOKEN USANDO EL GUARDADO
   * (opcional si quieres llamarlo directo)
   *****************************************/
  keycloakRefreshToken(): Observable<any> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded;'
    );

    const storedRefresh = this.localStorage.getItem('refresh_token') || '';

    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', storedRefresh)
      .set('client_id', environment.clientId);

    return this.http.post<any>(
      `${environment.apiUrl}/realms/${environment.realm}/protocol/openid-connect/token`,
      body.toString(),
      { headers }
    ).pipe(
      tap(resp => {
        const accessToken = resp.access_token;
        const refreshToken = resp.refresh_token;

        this.localStorage.setItem('token', accessToken);
        this.localStorage.setItem('refresh_token', refreshToken);

        //this.autoLogout.scheduleFromRefreshToken(refreshToken);
      })
    );
  }

  /*****************************************
   * REFRESH TOKEN USADO POR EL INTERCEPTOR
   *****************************************/
  refreshToken(refreshToken: string): Observable<any> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded;'
    );

    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('client_id', environment.clientId)
      .set('refresh_token', refreshToken);

    return this.http.post<any>(
      `${environment.apiUrl}/realms/${environment.realm}/protocol/openid-connect/token`,
      body.toString(),
      { headers }
    ).pipe(
      tap(resp => {
        const newAccessToken = resp.access_token;
        const newRefreshToken = resp.refresh_token;

        this.localStorage.setItem('token', newAccessToken);
        this.localStorage.setItem('refresh_token', newRefreshToken);

        // Reprogramar auto-logout con el NUEVO refresh token
        //this.autoLogout.scheduleFromRefreshToken(newRefreshToken);
      })
    );
  }

  /*****************************************
   * INFO DEL USUARIO DESDE EL ACCESS TOKEN
   *****************************************/
  public getUserInfo() {
    if (this.getIsLogged()) {
      const token = this.localStorage.getItem('token');
      if (!token) return null;

      const payload = token.split('.')[1];
      const payloadDecodedJson = atob(payload);
      return JSON.parse(payloadDecodedJson);
    }
    return null;
  }

  public getUserToken() {
    if (this.getIsLogged()) {
      return this.localStorage.getItem('token');
    }
    return null;
  }

  public getIsSuperAdmin(): boolean {
    const assignedSuperAdmin = this.localStorage.getItem('assignedSuperAdmin');
    return !!assignedSuperAdmin;
  }

  public getMenuAdmin(): Array<any> {
    const assignedSuperAdmin = this.localStorage.getItem('assignedSuperAdmin');
    const menus = assignedSuperAdmin;

    if (menus) {
      const adminMenus = menus.modules
        .filter(module => module.name === "ADMIN")
        .flatMap(menu => menu.menus);
      return adminMenus;
    }

    return [];
  }

  public getIsLogged(): boolean {
    return (this.localStorage.getItem('token') != null);
  }

  /*****************************************
   * LOGOUT GLOBAL
   *****************************************/
  logout() {
    if (this.isLoggingOut) {
      return;
    }
    this.isLoggingOut = true;
    Swal.close();
    this.localStorage.removeItem('token');
    this.localStorage.removeItem('refresh_token');
    this.localStorage.clear();

    this.routes.navigate(['/login']).finally(() => {
      this.isLoggingOut = false;
      window.location.reload();
    });
  }
}
